/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfTagDto } from "../models/AjaxResponseOfListOfTagDto";
import type { AjaxResponseOfTagDto } from "../models/AjaxResponseOfTagDto";
import type { CreateOrUpdateTagDto } from "../models/CreateOrUpdateTagDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class TagAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfTagDto Success
   * @throws ApiError
   */
  public getAllTags({
    filter,
  }: {
    filter?: string;
  }): CancelablePromise<AjaxResponseOfListOfTagDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/tags",
      query: {
        filter: filter,
      },
    });
  }
  /**
   * @returns AjaxResponseOfTagDto Success
   * @throws ApiError
   */
  public createOrUpdateTag({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateTagDto;
  }): CancelablePromise<AjaxResponseOfTagDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/tags",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public deleteTag({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/tags/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfTagDto Success
   * @throws ApiError
   */
  public getTag({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfTagDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/tags/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
}
